module.exports = __webpack_public_path__ + "img/istock-907916910.10fd970a.jpg";